module.exports = __webpack_public_path__ + "static/media/bcom-marketing_LR.4edf4132.jpg";